// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"42fa0f5e9c08d6ea86d4","339":"a648731f80678e415588"}[chunkId] + ".js";
};